import React from 'react';
import AccessTime from '@material-ui/icons/AccessTime';

import getFormError from './getFormError';
import CustomSelect from '../../../../../../components/CustomInput/CustomSelect';
import { datesObjType, fieldType, formType } from './types';
import { path } from '../../../../../../utils';

const buildOption = opt => ({
  text : `${opt.from}-${opt.to}`,
  value: opt,
});

const TimeSelector = ({
  field,
  form,
  dates,
}) => {
  const key = field.name.split('.')[1];
  const selectedDate = path(`values.service.${key}.date`, form);
  const options = dates[selectedDate] || [];
  const errorsObj = getFormError(form, `service.${key}.time`);
  const error = errorsObj ? errorsObj.from : null;
  const label = `${key === 'pickup' ? 'Pickup' : 'Delivery'} time`;
  const parsedOptions = options.map(buildOption);
  const disabled = options.length === 0;
  return (
    <CustomSelect
      data-testid="select.pickup-time"
      error={!!error}
      helpText={error}
      id={field.name}
      labelText={label}
      formControlProps={{ fullWidth: true }}
      inputProps={{
        ...field,
        disabled,
      }}
      options={parsedOptions}
      IconComponent={AccessTime}
    />
  );
};

TimeSelector.propTypes = {
  field: fieldType.isRequired,
  form : formType.isRequired,
  dates: datesObjType.isRequired,
};

export default TimeSelector;
